<script>
  import easyload from "../assets/img/easyload.png";
  import kazang from "../assets/img/kazang.png";
  import foryou from "../assets/img/foryou.png";
  import toomuchwifi from "../assets/img/toomuchwifi.png";
  import ott from "../assets/img/ott.png";
  import hotspotLogo from "../assets/img/hotspot.png";
  import back from "../assets/img/back.png";
  import NoVoucher from "./components/NoVoucher.svelte";
  import Gap from "./components/Gap.svelte";
  import LoadingIndicator from "./components/LoadingIndicator.svelte";
  import Error from "./components/Error.svelte";

  export let store;

  let isLoading = false;

  let vendorSelectionMode = true;

  const voucherVendors = {
    easyload: easyload,
    kazang: kazang,
    "1foryou": foryou,
    toomuchwifi: toomuchwifi,
    ott: ott,
  };

  let selectedVendor = null;
  let selectedVendorLogo = null;

  let voucherCode = null;
  //to be used when endpoint to redeem voucher accepts vounder
  let allocationTo = null;
  let errorMessage = null;
  let errorMessageDetails = null;
  const portalURL = import.meta.env.VITE_BASE_PORTAL_URL;

  function setSelectedVendor(vendor) {
    selectedVendor = vendor;
    selectedVendorLogo = voucherVendors[vendor];

    vendorSelectionMode = false;
  }

  function hideError() {
    setTimeout(() => {
      errorMessage = null;
    }, 2000); // Error will disappear after 3 seconds
  }

  async function redeemVoucher() {
    if (!selectedVendor) {
      errorMessage = "Please select a vendor.";
    }
    if (!voucherCode) {
      errorMessage = "Please enter a voucher code.";
    }

    isLoading = true;

    try {
      let response = await fetch(`${portalURL}hotspot/voucher/device/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          voucher_vendor: selectedVendor,
          voucher: voucherCode,
          cellphone: store.cellphone,
          mac_address: store.macAddress,
        }),
      });

      if (response.ok) {
        let data = await response.json();
        errorMessage = data.message;

        store.setState("ACCOUNT");
      } else {
        let data = await response.json();
        errorMessage = "Error redeeming voucher";
        errorMessageDetails =
          "Please make sure you have a valid voucher and try again";
      }
    } catch (error) {
      errorMessage = "Error redeeming voucher";
      errorMessageDetails =
        "Please make sure you have a valid voucher and try again";
    } finally {
      if (errorMessage) {
        hideError();
      }
    }
    isLoading = false;
  }

  function backButton() {
    if (vendorSelectionMode === false) {
      vendorSelectionMode = true;
    } else {
      store.setState("ACCOUNT");
    }
  }
</script>

<div class="flex flex-col items-center justify-center mx-4 w-full px-2 py-6">
  <div class="w-full">
    <button class="flex flex-row" on:click={() => backButton()}>
      <img class="w-3" src={back} alt="Back button" />
      <div class="w-1"></div>
      <p class="text-[#5b95c8] text-md font-bold mx-2">Back</p>
    </button>
  </div>

  <!-- Logo Section -->
  <div class="flex justify-center w-full mb-4">
    <img src={hotspotLogo} alt="TooMuchWifi Hotspot" class="w-2/5" />
  </div>

  <Gap h="14" />

  {#if isLoading}
    <LoadingIndicator width="150px" />
  {:else}
    {#if vendorSelectionMode === true}
      <div class="flex flex-col">
        <p class="font-medium text-md">What type of voucher do you have?</p>

        <Gap h="6" />

        <div class="flex justify-center max-w-4xl mx-auto">
          {#each Object.entries(voucherVendors) as [name, logo]}
            <div class="text-center w-1/5">
              <button
                on:click={() => setSelectedVendor(name)}
                class="p-2 rounded-md shadow-md cursor-pointer flex items-center justify-center mx-1 h-14 w-14"
              >
                <img
                  src={logo}
                  alt={name}
                  class="max-h-full max-w-full object-contain"
                />
              </button>
            </div>
          {/each}
        </div>
      </div>

      <Gap h="6" />

      {#if errorMessage}
        <Error message={errorMessage}></Error>
      {/if}

      <Gap h="14" />

      <NoVoucher {store} />
    {/if}

    {#if vendorSelectionMode === false && selectedVendor != null}
      <div class="flex flex-col items-center justify-center max-w-4xl py-6">
        <p class="font-medium w-full text-md">Enter your voucher code</p>

        <Gap h="6" />

        <div class="border border-gray-300 flex flex-row rounded-md">
          <button
            on:click={() => backButton()}
            class="bg-white rounded-tl-md rounded-bl-md border-r-[1px] border-gray-400"
          >
            <div class="p-2">
              <img
                src={selectedVendorLogo}
                alt={`${selectedVendor} Logo`}
                class="max-h-10 max-w-14 object-contain"
              />
            </div>
          </button>
          <input
            type="pin"
            id="pin"
            required
            maxlength="20"
            minlength="12"
            placeholder="Voucher Code"
            class="px-2 py-5 rounded-tr-md rounded-br-md w-full"
            bind:value={voucherCode}
          />
        </div>

        <Gap h="6" />

        <button
          on:click={() => redeemVoucher()}
          class="bg-[#009946] py-5 text-white font-bold rounded-md w-full"
        >
          Connect
        </button>

        <Gap h="14" />

        <NoVoucher {store} />
      </div>
    {/if}
  {/if}
</div>
